
export default {
  data() {
    return {
      test: ''
    };
  }
};
